/**
 * https://github.com/gengfire/vue-popup-plugin
 * @type {Object}
 */
export function Tips(Vue) {
  let instances = []
  let count = 1
  let TipsConstructor = Vue.extend(require('./tips.vue'))

  var tips = function(options) {
    options = options || {}
    if (typeof options === 'string') {
      options = {
        tips: options
      }
    }
    const userOnHide = options.onHide
    const id = 'Tips-' + count++

    options.onHide = function() {
      tips.hide(id, userOnHide)
    }

    const instance = new TipsConstructor({
      data: options
    })
    instance.id = id
    instance.vm = instance.$mount()
    document.body.appendChild(instance.vm.$el)
    instance.vm.visible = true
    instance.dom = instance.vm.$el
    instances.push(instance)
  }

  tips.hide = function(id, onHide) {
    for (let i = 0, len = instances.length; i < len; i++) {
      if (id === instances[i].id) {
        if (typeof onHide === 'function') onHide(instances[i])
        instances.splice(i, 1)
        break
      }
    }
  }

  Vue.prototype.$tips = tips
}

export function AlertBox(Vue) {
  let instances = []
  let count = 1
  let AlertBoxConstructor = Vue.extend(require('./alertbox.vue'))
  // let alertBox = (content,callback,isBackgroundTransparent=false,cancel="取消",confirm="确定",title='提示') => {
  let alertBox = (content, callback, confirm = '确定', cancel = '取消', title = '提示', isBackgroundTransparent = false) => {
    const id = 'AlertBox-' + count++
    const instance = new AlertBoxConstructor({
      data: {
        content: content,
        title: title,
        confirm: confirm,
        cancel: cancel,
        isBackgroundTransparent,
        onHide: (index) => {
          if (callback) callback(index)
          alertBox.hide(id)
        }
      }
    })
    instance.id = id
    instance.vm = instance.$mount()
    document.body.appendChild(instance.vm.$el)
    instance.vm.coverVisible = instances.length === 0
    instance.vm.visible = true
    instance.dom = instance.vm.$el
    instances.push(instance)
  }

  alertBox.hide = function(id) {
    for (let i in instances) {
      if (id === instances[i].id) {
        instances.splice(i, 1)
        break
      }
    }
  }

  alertBox.hideAll = function() {
    instances.forEach(i => {
      // alertBox.hide(i.id)
      document.body.removeChild(i.dom)
    })
    instances = []
  }
  Vue.prototype.$alert = alertBox
}

export function Loading(Vue) {
  let count = 0
  let instance
  const LoadingConstructor = Vue.extend(require('./loading.vue'))
  const loading = (isLoading = true, text) => {
    if (isLoading && count === 0) { // loading
      count++
      if (!instance) {
        instance = new LoadingConstructor({
          data: {
            coverVisible: false,
            visible: false,
            text
          }
        })
        instance.vm = instance.$mount()
        document.body.appendChild(instance.vm.$el)
      }
      instance.vm.visible = true
    } else if (!isLoading && count === 1) { // remove
      count = 0
      instance.vm.visible = false
    }
  }
  Vue.prototype.$loading = loading
}
